<template>
  <div class="scmcc-home-page" v-if="sign">
    <div class="home-component" style = "padding-top:0;" >
      <component :is="'HelloComponent'" ref="hello"></component>
    </div>
    <div class="home-component" v-for="item in homeComponents" :key="item.name">
      <component :is="item.name" v-model="item.config"></component>
    </div>
    <Spin fix v-if="loading"></Spin>
    <Modal
      v-model="arrearageFlag"
      width="400"
      title="停用通知"
      class="arrearage-tip"
    >
      <p style="padding-bottom: 40px">您的企业余额不足，坐席账号及业务人员账号已被限制登录，请联系管理员续费</p>
      <div slot="footer">
          <Button type="primary" size="large" @click="arrearageFlag=false">我知道了</Button>
      </div>
    </Modal>
  </div>
  <div class="scmcc-home-page" v-else>
    <div class="home-component">
      <component :is="'HelloComponent'" ref="hello"></component>
    </div>
  </div>
</template>
<script>
import HelloComponent from './settings/HelloComponent';
export default {
  name: 'home',
  components: {
    HelloComponent
  },
  data() {
    return {
      loading: true,
      sign: false,
      homeComponents: [],
      arrearageFlag: false,
    }
  },
  watch: {
    '$store.state.main.modulesIsLoaded': {
      handler(val) {
        if (val) this.loadingHome()
      },
      immediate: true
    }
  },
  created(){
    let isArrears = localStorage.isArrears;
    this.arrearageFlag = isArrears == 1 ? true : false
  },
  methods: {
    loadingHome() {
      // console.log('333', JSON.parse(localStorage.user).info.userType)
      if (JSON.parse(localStorage.user).info.userType !== '1') {
        //不是超级管理员
        this.sign = true
      } else {
        return
      }
      this.$http.get('/sctm/getModuleIds').then(res => {
        if (res.data.returnCode == 0 && res.data.bean !== '') {
          this.homeComponents = JSON.parse(res.data.bean)
        } else {
          console.log('首页查询组件接口res.data.bean', res.data.bean)
        }
      })
      this.loading = false
    }
  }
}
</script>
<style lang="less">
.scmcc-home-page {
  width:100%;
  .home-component {
    width:100%;
    padding: 8px;
  }
}
</style>
